<template>
  <v-card outlined rounded="lg" class="pa-3 mb-4 process-stepper-card">
    <div class="d-flex flex-wrap align-center">
      <div
        v-for="(step, i) in steps"
        :key="step.key"
        class="d-flex align-center step-item"
      >
        <router-link :to="step.to" class="step-link" :class="{ 'step-current': step.key === current }">
          <v-avatar :color="step.key === current ? '#B3151B' : '#ECEFF1'" size="30" class="mr-2">
            <span :class="step.key === current ? 'white--text' : 'grey--text text--darken-2'" class="font-weight-bold">{{ i + 1 }}</span>
          </v-avatar>
          <span class="step-text">{{ step.text }}</span>
          <v-chip v-if="step.count" x-small color="error" dark class="ml-1">{{ step.count }}</v-chip>
        </router-link>
        <v-icon v-if="i < steps.length - 1" class="mx-2 step-arrow" color="grey lighten-1">mdi-chevron-right</v-icon>
      </div>
    </div>
  </v-card>
</template>

<script>
// แถบแสดงขั้นตอนการโยกย้าย/สับเปลี่ยน/เกลี่ยตำแหน่งพนักงานราชการ ให้เห็นภาพรวมกระบวนการทั้ง 3 ขั้น
// เป็นเพียงป้ายนำทาง (ไม่ใช่ wizard บังคับทำตามลำดับ) เพราะบางกรณีส่วนกลางดำเนินการขั้นที่ 1 นอกระบบ
// (ประกาศผลโยกย้ายโดยไม่ผ่าน transfer_requests) สถานศึกษาจึงอาจเริ่มที่ขั้น 2 หรือ 3 ได้โดยตรง
export default {
  name: "GovEmProcessStepper",
  props: {
    current: { type: String, required: true }, // 'transfer' | 'manpower' | 'contract'
    pendingTransferCount: { type: Number, default: 0 },
    contractGapCount: { type: Number, default: 0 }
  },
  computed: {
    steps() {
      return [
        {
          key: "transfer",
          text: "1. โยกย้าย/สับเปลี่ยน/เกลี่ยตำแหน่ง",
          to: "/college/gov_em/transfer_requests",
          count: this.pendingTransferCount
        },
        {
          key: "manpower",
          text: "2. ตรวจสอบกรอบอัตรากำลัง",
          to: "/college/gov_em/government_employee",
          count: 0
        },
        {
          key: "contract",
          text: "3. แนบสัญญาจ้างเพิ่มเติม",
          to: "/college/gov_em/government_employee",
          count: this.contractGapCount
        }
      ];
    }
  }
};
</script>

<style scoped>
.process-stepper-card {
  background: #fafafa !important;
}
.step-item {
  margin-bottom: 4px;
}
.step-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 4px 8px;
  border-radius: 8px;
  color: #424242;
}
.step-link:hover {
  background: #eceff1;
}
.step-current {
  background: #fdeeee;
}
.step-text {
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
}
.step-arrow {
  flex-shrink: 0;
}
</style>
